<template>
  <form-panel
    :title="edit ? 'Editar objetivos' : 'Nuevos objetivos'"
    width="short"
    @closePanel="closeModal">
    <goals-form
      :edit="edit"
      :item="item"
      :item-type="itemType"
      :items="items"
      :goals="goals"
      @onCreate="onCreate"/>
  </form-panel>
</template>

<script>
import GoalsForm from '@/modules/goals/goals-form'
import FormPanel from '@/components/_shared/form-panel'
export default {
  name: 'GoalsCreatePanel',
  components: {
    FormPanel,
    GoalsForm
  },
  props: {
    item: {
      type: Object,
      default: null
    },
    itemType: {
      type: String,
      default: 'dealer' // dealer, branch, seller
    },
    items: {
      type: Array,
      default () {
        return []
      }
    },
    goals: {
      type: Array,
      default: null
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      profileForm: {},
      dataOld: {}
    }
  },
  methods: {
    closeModal () {
      this.$emit('closeModal')
    },
    onCreate () {
      this.$emit('closeModal')
      this.$emit('onCreate')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/app/goals/goals-create-panel.vue